require('../modules/esnext.global-this');

module.exports = require('../internals/global');



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/proposals/global-this.js
// module id = 673
// module chunks = 4